/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import { Navbar } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BaseComponent from '../../../panther/components/base/BaseComponent';

import MicrositeHeader from './MicrositeHeader/MicrositeHeader';
import MicrositeNavigation from './MicrositeNavigation/MicrositeNavigation';

import styles from './MicrositeNavBar.css';

class MicrositeNavBar extends BaseComponent {
    constructor() {
        super();
        this.state = {
            mobileNavOpen: false
        }
    }

    onMenuButtonClick(){
        this.setState({
            mobileNavOpen: !this.state.mobileNavOpen
        })
    }

    render() {
        let classes = classNames(
            'microsite-navbar', {
                'scrolled': this.props.scrolled,
            },
            this.props.className
        );

        return (
            <Navbar
                className={classes}
                fixedTop
            >
                <MicrositeHeader
                    intro={this.props.intro}
                    menuButtonOnClick={this.onMenuButtonClick.bind(this)}
                />
                <MicrositeNavigation
                    mobileNavOpen={this.state.mobileNavOpen}
                    menuItemOnClick={this.onMenuButtonClick.bind(this)}
                    sections={this.props.sections}
                />
            </Navbar>
        );
    }
}

MicrositeNavBar.propTypes = {
    intro: PropTypes.object,
    sections: PropTypes.array,
    scrolled: PropTypes.bool
};

export default MicrositeNavBar;